import base from './base';
import axios from "axios";

export default class extends base {
    static get uri() {
        return 'cards';
    }

    static visits(id, params = {}) {
        return axios.get(`${this.uri}/${id}/visits`, {
            params
        });
    }
}
